import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import { POPUP_COMPONENTS, PopupType } from './usePermissionPopupHandler.types';

export function usePermissionPopupHandler() {
	const [searchParams, setSearchParams] = useSearchParams();
	const { pushLayer } = useUILayerStore();

	useEffect(() => {
		const searchParamsPopupType = searchParams.get('popup');

		// 팝업 타입이 유효하면 해당 컴포넌트 표시
		if (searchParamsPopupType && searchParamsPopupType in POPUP_COMPONENTS) {
			const PopupComponent = POPUP_COMPONENTS[searchParamsPopupType as PopupType];
			pushLayer('modal', <PopupComponent />);
		}

		// 검색 파라미터 초기화
		setSearchParams('', { replace: true });
	}, []);
}
